<template>
  <div>
    <h5
      class="py-4 card-text mb-5"
    >
      Creative Logo
    </h5>
    <logo-upload
      logo-type="unit"
    />
  </div>
</template>
<script>
import LogoUpload from '@/modules/content/components/PreviewRightPanel/LogoUpload';

export default {
  name: 'CreativeLogo',
  components: {
    LogoUpload,
  },
};
</script>
<style lang="scss" scoped>
* {
  margin: 0px;
  padding: 0px;
}
</style>
